const LEGACY_CACHE_NAME_PREFIXES = ['dotnet-resources-', 'blazor-resources-'];

function isLeftBehindByBlazor(cacheName: string): boolean {
  return LEGACY_CACHE_NAME_PREFIXES.some((prefix) => cacheName.startsWith(prefix));
}

export async function dropCachesLeftBehindByBlazor(): Promise<void> {
  if (!('caches' in window)) {
    return;
  }

  try {
    const cacheNames = await window.caches.keys();
    await Promise.all(
      cacheNames.filter(isLeftBehindByBlazor).map((cacheName) => window.caches.delete(cacheName)),
    );
  } catch (error) {
    console.warn('Dropping the caches left behind by the Blazor Portal failed.', error);
  }
}
